import { FC } from "react";

export const HubStationTemplateLoading: FC = () => (
  <span className="hub-station-loading" />
);
